import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { TravelReimbursementService } from '../../services/travel-reimbursement.service';
import { reimbursementUrl, travelAuthorUrl, itineraryRBUrl, BOOKINGTYPE, BOOKINGMETHOD, PURPOSE } from 'src/app/modules/shared/common/api';
import { TravelReimbursementApproveListComponent } from '../travel-reimbursement-approve-list/travel-reimbursement-approve-list.component';
import { User } from 'src/app/models/user';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { ItineraryDetailsComponent } from 'src/app/modules/shared/components/itinerary-details/itinerary-details.component';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { TravelItineraryViewComponent } from 'src/app/modules/shared/components/travel-itinerary-view/travel-itinerary-view.component';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';

@Component({
  selector: 'app-travel-reimbursement-add',
  templateUrl: './travel-reimbursement-add.component.html',
  styleUrls: ['./travel-reimbursement-add.component.scss']
})
export class TravelReimbursementAddComponent implements OnInit {

  travel: Travel;
  user: User;
  formGroup: FormGroup;
  loading:boolean = false;
  isOther:boolean = false;
  listResult:boolean = false;
  isNoResult:boolean = false;
  successMessage: String = '';
  total = 0;
  mealTotal = 0;
  transportFee = 0;
  totalCashAdvance = 0;
  selectedIndex = 0;
  taList:any; //Travel Authorization Number
  isCharged:boolean = false;
  isCurrency:boolean = false;

  dialogConfig:any;
  summaryDetail:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  headlabel = 'View';
  objectKeys = Object.keys;
  expensesList:any;

  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];

  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];
  bookedOption = BOOKINGTYPE;
  bookedMethod = BOOKINGMETHOD;
  billOption = ["Store Support Center","Requestor"];

  province = [{origin:''},{destination: ''}];
  city = [{city:''},{city: ''}];
  barangay = [{barangay:'' },{barangay: ''}];

  pipe = new DatePipe('en-US');
 

  constructor(
    public dialogRef: MatDialogRef<TravelReimbursementAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public reimburseService: TravelReimbursementService,
    private formBuilder: FormBuilder,
    public functionService:FunctionsService,
    public dialog: MatDialog,
    public travelService: TravelService,
    public auth: AuthService,
  ) { }

  ngOnInit() {
    this.travel = new Travel('');
    this.user = new User(this.auth.getAuthUser());
    this.formGroup = this.formBuilder.group({
      date_filed:['',null],
      itinerary_date: ['',null],
      travel_request: ['',null],
      travel_request_id: ['',null],
      travel_request_type: ['',null],
      employee_id: ['',null],
      employee_name: ['',null],
      booking_type: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      department: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      travel_type: ['',null],
      copy_date: ['',null],
      purpose: ['',null],
      location: ['',null],
      nature: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      currency: ['',null],
      amount: ['',null],
      charged_to: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      cash_advance_no:['',null],
      cash_advance_id:['',null],
      cash_for_reimbursement: ['',null],
      amount_for_reimbursement:['',null],
      travel_summary_id:['',null],
      misc_breakdown:['',null],
      others:['',null]
    });
    this.formGroup.controls['misc_breakdown'].setValue(this.travel.misc_breakdown);
    this.travel.formGroup = this.formGroup;
    this.travel.disableForm();
    this.formGroup.controls['travel_request'].enable();
    this.formGroup.controls['travel_request_id'].enable();
    this.formGroup.controls['travel_summary_id'].enable();
    this.formGroup.controls['misc_breakdown'].enable();
    this.formGroup.controls['cash_for_reimbursement'].enable();
    this.formGroup.controls['amount_for_reimbursement'].enable();
    this.formGroup.controls['is_draft'].enable();

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

  }
  
  closeOnClick() {
    let detail = [];
    this.dialogRef.close(true);
    if (this.travel.itineraries) {
      this.travel.itineraries.forEach(element => {
        if (element.travel_itinerary_reimbursement) {
          detail.push(
            {
              itinerary_liquidation: (element.travel_itinerary_reimbursement)? element.travel_itinerary_reimbursement.id : null,
              itinerary_detail_reimbursement: []
            }
          );
        }

        element.travel_itinerary_details.forEach((el,i) => {
          if (el.travel_itinerary_detail_reimbursement) {
            detail[i].itinerary_detail_reimbursement.push({id:el.travel_itinerary_detail_reimbursement.id});
          }
        });
      }); 
    }

    if (detail.length > 0) {
      let data = {
        travel_request_id: this.formGroup.controls['travel_request_id'].value ,
        detail: detail,
        status: 'delete'
      }
      this.reimburseService.deleteliquidation(data).subscribe(res=>{
      });
    }
  }
  
  getTransaction(){
    let param = [];
    let queryString = '';

    param.push('type=for-reimbursement');

    if(this.formGroup.controls['travel_request'].value !== null){
      param.push('travel_request='+this.formGroup.controls['travel_request'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.reimburseService.url = travelAuthorUrl+'/approved/'+ queryString;
    this.reimburseService.getFilter().subscribe(res=>{
      
      if (res.length) {
        this.travel = new Travel(res[0]);
        this.data = {
          isOther:false,
          res:res[0]
        }
        this.formGroup.controls['travel_request_type'].setValue(res[0].travel_request_type);
        this.formGroup.controls['employee_id'].setValue(res[0].employee_id);
        this.formGroup.controls['employee_name'].setValue(res[0].employee_name);
        this.formGroup.controls['booking_type'].setValue(res[0].travel_summary.booking_type);
        this.formGroup.controls['employee_id_no'].setValue(this.user.employee_id);
        this.formGroup.controls['area_covered'].setValue(res[0].area_covered);
        this.formGroup.controls['bill_to'].setValue(res[0].travel_summary.bill_to);
        this.formGroup.controls['position'].setValue(res[0].position);
        this.formGroup.controls['department'].setValue(res[0].department);
        this.formGroup.controls['payroll_acct_no'].setValue(res[0].payroll_acct_no);
        this.formGroup.controls['booked_by'].setValue(res[0].travel_summary.booked_by);
        this.formGroup.controls['charged_to'].setValue(res[0].travel_summary.charged_to);
        this.formGroup.controls['currency'].setValue(res[0].travel_summary.currency_category_value);
        this.formGroup.controls['currency_category'].setValue(res[0].travel_summary.currency_category);
        this.formGroup.controls['charged_to_category'].setValue(res[0].travel_summary.charged_to_category);
        this.formGroup.controls['inclusive_date_from'].setValue(res[0].travel_summary.inclusive_date_from);
        this.formGroup.controls['inclusive_date_to'].setValue(res[0].travel_summary.inclusive_date_to);
        this.formGroup.controls['location'].setValue(res[0].travel_summary.location);
        this.formGroup.controls['nature'].setValue(res[0].travel_summary.nature);
       // this.formGroup.controls['purpose'].setValue(res[0].travel_summary.purpose);
        this.formGroup.controls['travel_type'].setValue(res[0].travel_summary.travel_type);
        this.formGroup.controls['travel_request_id'].setValue(res[0].travel_itineraries[0].travel_request_id);
        this.formGroup.controls['itinerary_date'].setValue(res[0].itinerary_date);
        this.formGroup.controls['cash_advance_id'].setValue(res[0].id);
        this.travel.totalExpenses = 0;
        this.totalCashAdvance = res[0].travel_itinerary_total.grand_total;
        this.travel.itineraries = res[0].travel_itineraries;
        this.formGroup.controls['others'].setValue(res[0].travel_summary.others);
        let purposeOption = res[0].travel_summary.purpose.split("|");
        this.formGroup.controls['purpose'].setValue(purposeOption[0]);
        if (purposeOption[0] == "OTHERS") {
          this.isOther = true;
          this.data.isOther = true;
          //this.formGroup.controls['others'].setValue(purposeOption[1]);
        }

        if (res[0].travel_summary.currency_category == 3) {
          this.isCurrency = true;
        }

        res[0].travel_itineraries.forEach((element,i) => {
          res[0].travel_itineraries[i].travel_itinerary_details.forEach((element,x) => {
            res[0].travel_itineraries[i].travel_itinerary_details[x].travel_itinerary_detail_reimbursement = {};
          });
          res[0].travel_itineraries[i].travel_itinerary_reimbursement = { total_actual_expense: 0 } 
        });
        this.expensesList  = this.functionService.loopRangeDate(
          [res[0].travel_summary.inclusive_date_from,res[0].travel_summary.inclusive_date_to],
          res[0].travel_itineraries
        );
        this.travel.getTotal();
      } else {
        this.travel.id = null;
        this.isNoResult = true;
      }  
      this.loading = false;
    });
  }

  save(bool:boolean = false){
    this.loading = true;
    this.formGroup.controls['is_draft'].setValue(bool);
    this.formGroup.controls['cash_advance_id'].setValue(this.travel.list.id);
    this.formGroup.controls['travel_request_id'].setValue(this.travel.list.travel_summary.travel_request_id);
    this.formGroup.controls['travel_summary_id'].setValue(this.travel.list.travel_summary.id);
    this.reimburseService.storeLiquidation(this.formGroup.value).subscribe(res=>{
      
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(this.formGroup.value);
        }
      });
    },(err => {
      this.loading = false;
      this.travel.formGroup = this.formGroup;
      if (err.error.errors.mismatch) {
        var self = this;
        var emptyKey = 0;
        var continueLoop = true

        Object.keys(this.expensesList).forEach((element,i) => {
          if(this.expensesList[element].travel_itinerary_reimbursement_list.length == 0) {
            if (continueLoop) {
              emptyKey = i;
              continueLoop = false;
            }
          }
        });

        this.openLiquidation(this.expensesList[Object.keys(this.expensesList)[emptyKey]],this.expensesList,this.expensesList[Object.keys(this.expensesList)[emptyKey]].travel_itinerary_reimbursement)
        setTimeout(function(){
          self.dialog.open(NotifyboxComponent, {
            disableClose:true,
            data: {
              reload:false,
              label:'Ok',
              message: err.error.errors.mismatch[0]
            }
          });
        },800);
      }
      if (this.selectedIndex == 0) {
        this.selectedIndex = 1;
      }
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  approvelist() {
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelReimbursementApproveListComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formGroup.controls['travel_request'].setValue(result.travel_request.travel_request);
      }
    });
  }

  saveAsDraft(){
    this.save(true);
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  searchKey(e){
    if (e.target.value.length > 2) {
      this.reimburseService.url = travelAuthorUrl +'/approved/?type=for-reimbursement&travel_request='+e.target.value;
      this.reimburseService.getFilter().subscribe(res=>{
        this.listResult = true;
        this.taList = res;
      });
    }
  }

    /**
   * Open liquidaiton Detail
   */
  openLiquidation(res,detail,val?:number){
    this.dialogConfig.width = '100vw';
    this.dialogConfig.panelClass = 'my-full-screen-dialog';
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = {
      res,
      detail,
      cash_id: this.formGroup.controls['cash_advance_id'].value,
      type:'reimbursement',
      mode: (val)? 1 : 0,

      isEdit: (val)? true : false ,
      url:itineraryRBUrl
    }

    let dialogRef = this.dialog.open(ItineraryDetailsComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.travel.clearTotal();
        if (val) {
          this.travel.itineraries = result.travel_itineraries;
          this.expensesList  = this.functionService.loopRangeDate(
            [result.travel_summary.inclusive_date_from,result.travel_summary.inclusive_date_to],
            result.travel_itineraries
          );
        } else {
          this.travel.itineraries = result.travel_itineraries;
          this.expensesList  = this.functionService.loopRangeDate(
            [result.travel_summary.inclusive_date_from,result.travel_summary.inclusive_date_to],
            result.travel_itineraries
          );
        }
        this.travel.getTotal();
      }  
    });
  }

    /**
   * Display Currency option
   * @param e = 3 get value for other currency
   */
  displayCurrency(e) {
    this.isCurrency = false;
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCurrency = true;
      }
    })
  }

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.isCharged = false;
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCharged = true;
      }
    })
  }

  next(e) {
    this.selectedIndex = e;
  }

  /**
   * View itinerary Details Modal
   * @param res 
   */
  viewItinerary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 1,
      displayEdit: false
    }
    let dialogRef = this.dialog.open(TravelItineraryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

}
